if (!customElements.get('mobile-dock')) {
    customElements.define('mobile-dock', class MobileDock extends HTMLElement {
        constructor() {
            super();
            if (Shopify.designMode) {
                this.init();
            }
            else {
                new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
            }
        }
        // The header's scroll state shows the dock through CSS alone, so the
        // sticky forms and the footer read --mobile-dock-height before init
        // (first interaction, or 5s) has run; the height has to be published
        // as soon as the dock has one, and again whenever its stylesheet lands.
        connectedCallback() {
            this.resizeObserver = new ResizeObserver(this.setHeight.bind(this));
            this.resizeObserver.observe(this);
        }
        disconnectedCallback() {
            this.resizeObserver.disconnect();
        }
        get section() {
            return this._section = this._section || this.closest('.mobile-dock-section');
        }
        init() {
            if (this.initialized)
                return;
            this.initialized = true;
            this.setAttribute('loaded', '');
            this.detectForHeader();
            this.detectForFooter();
            if (Shopify.designMode) {
                this.section.addEventListener('shopify:section:select', () => {
                    this.section.classList.add('shopify-active');
                });
                this.section.addEventListener('shopify:section:deselect', () => {
                    this.section.classList.remove('shopify-active');
                });
            }
        }
        detectForHeader() {
            const header = document.querySelector('.header-section');
            if (header === null) {
                this.section.classList.add('active');
                return;
            }
            if (!header.classList.contains('header-sticky')) {
                this.scrollY = parseInt(header.getBoundingClientRect().bottom);
                window.addEventListener('scroll', theme.utils.throttle(this.onScrollForHeader.bind(this)), false);
            }
        }
        onScrollForHeader() {
            if (window.scrollY >= this.scrollY) {
                this.section.classList.add('active');
            }
            else {
                this.section.classList.remove('active');
            }
        }
        detectForFooter() {
            const footer = document.querySelector('.footer-copyright');
            if (footer === null)
                return;
            window.addEventListener('scroll', theme.utils.throttle(this.onScrollForFooter.bind(this)), false);
        }
        onScrollForFooter() {
            if (!theme.config.mqlSmall)
                return;
            const scrolledTo = window.scrollY + window.innerHeight;
            const threshold = this.offsetHeight;
            const isReachBottom = document.body.scrollHeight - threshold <= scrolledTo;
            this.classList.toggle('active', isReachBottom);
        }
        setHeight() {
            document.documentElement.style.setProperty('--mobile-dock-height', `${this.getBoundingClientRect().height.toFixed(1)}px`);
        }
    }, { extends: 'nav' });
}
